import { memo } from 'react';
import { Button, Step, Stepper } from '@repo/design-system-kit';
import { IconArrowLeftOutlined, IconCrossOutlined } from '@repo/monochrome-icons';
import { useIntl } from 'react-intl';
import { webviewManager } from '@repo/shared-kit/webview';
import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';
import styles from './header.module.css';

const { frontendUrlsTable } = getUrlsTable(getEnvironmentVariables());

function onClose(): void {
  if (webviewManager.isWebview) {
    webviewManager.onFreemiumToPaidUpgradeClosed();
  } else {
    window.location.href =
      window.sessionStorage.getItem('qba__return_url') ?? frontendUrlsTable.appJsURL;
  }
}

export const BusinessAccountHeader = memo(function BusinessAccountHeader({
  stepper,
  onBack,
}: {
  stepper?: { steps: string[]; currentStep: number };
  onBack?: () => void;
}): JSX.Element {
  const { formatMessage } = useIntl();

  return (
    <nav className={styles.container}>
      {onBack === undefined ? (
        <div />
      ) : (
        <Button
          aria-label={formatMessage({
            id: 'customer-registration-kit.btn.back',
            defaultMessage: 'Back',
          })}
          iconOnly
          onPress={onBack}
          variant="tertiary"
        >
          <IconArrowLeftOutlined />
        </Button>
      )}

      {stepper === undefined || stepper.steps.length < 3 ? (
        <div />
      ) : (
        <Stepper currentStep={stepper.currentStep}>
          {stepper.steps.map(step => (
            <Step key={step} label={step} />
          ))}
        </Stepper>
      )}

      <Button
        aria-label={formatMessage({
          id: 'customer-registration-kit.btn.close',
          defaultMessage: 'Close',
        })}
        iconOnly
        onPress={onClose}
        variant="tertiary"
      >
        <IconCrossOutlined />
      </Button>
    </nav>
  );
});
